import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {PortvisitUtils} from "../../../../refdata/portvisit-utils";
import {HarbourDuesDeclaration} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-harbour-dues-admin-amsterdam',
  templateUrl: './harbour-dues-admin-amsterdam.component.html',
  styleUrls: ['./harbour-dues-admin-amsterdam.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HarbourDuesAdminAmsterdamComponent {
  @Input() declaration: HarbourDuesDeclaration;

  toOutgoingMessages() {
    let businessCorrelationId = this.declaration.crn + "_HarbourDues_" + this.declaration.statementNumber;
    PortvisitUtils.redirectToMessageManagement(businessCorrelationId);
  }
}
